import allStatesAndFips from 'shared/constants/mortgage/allStatesAndFips.json';

const stateToFipCode = Object.entries(allStatesAndFips).reduce(
	(acc, [state, counties]) => {
		acc[state] = Object.entries(counties).reduce(
			(acc, [county, fipCode]) => {
				acc[county] = fipCode;
				return acc;
			},
			{}
		);
		return acc;
	},
	{}
);

export default stateToFipCode;
